<script lang="ts">
  import { link } from 'svelte-spa-router'
  import { tStore } from '../../../i18n'

  let {
    pageCount,
    totalCount,
    activeSources,
    lastSuccessfulAt,
  }: {
    pageCount: number
    totalCount: number | null
    activeSources: number
    lastSuccessfulAt: string | null
  } = $props()
</script>

<div class="kpis">
  <article class="card kpi">
    <span class="kpi__label">{$tStore('views.dashboard.kpi.procurements')}</span>
    <span class="kpi__value">
      {pageCount}{totalCount !== null ? `/${totalCount}` : ''}
    </span>
  </article>
  <article class="card kpi">
    <span class="kpi__label">{$tStore('views.dashboard.kpi.activeSources')}</span>
    <span class="kpi__value">{activeSources}</span>
  </article>
  <article class="card kpi">
    <span class="kpi__label">{$tStore('views.dashboard.kpi.lastRun')}</span>
    <span class="kpi__value kpi__value--sm">
      {lastSuccessfulAt ?? '—'}
    </span>
  </article>
  <a href="/certificate-analysis" use:link class="card kpi kpi--link">
    <span class="kpi__label">{$tStore('views.dashboard.kpi.certificateAnalysis')}</span>
    <span class="kpi__value kpi__value--sm kpi__link-cta">
      {$tStore('views.dashboard.kpi.certificateAnalysisCta')}
      <span class="kpi__arrow" aria-hidden="true">→</span>
    </span>
  </a>
</div>

<style lang="scss">
  @use '../../../assets/styles/variables' as v;

  .kpis {
    display: grid;
    grid-template-columns: repeat(4, 1fr);
    gap: v.$space-md;

    @media (max-width: v.$bp-lg) {
      grid-template-columns: repeat(2, 1fr);
    }

    @media (max-width: v.$bp-sm) {
      grid-template-columns: 1fr;
    }
  }

  .kpi {
    display: flex;
    flex-direction: column;
    gap: v.$space-sm;
    position: relative;
    overflow: hidden;
    padding: v.$space-lg;

    &::before {
      content: '';
      position: absolute;
      inset: 0 auto 0 0;
      width: 3px;
      background: linear-gradient(180deg, v.$color-primary, #6366f1);
      opacity: 0.85;
    }

    &__label {
      color: v.$color-text-muted;
      font-size: 0.75rem;
      font-weight: 600;
      text-transform: uppercase;
      letter-spacing: 0.06em;
    }

    &__value {
      font-size: 2rem;
      font-weight: 700;
      line-height: 1;
      letter-spacing: -0.02em;
    }

    &__value--sm {
      font-size: 1rem;
      font-weight: 500;
      letter-spacing: 0;
    }
  }

  .kpi--link {
    text-decoration: none;
    color: inherit;
    cursor: pointer;
    transition:
      border-color 120ms ease,
      box-shadow 120ms ease,
      transform 120ms ease;

    &::before {
      background: linear-gradient(180deg, #10b981, #6366f1);
    }

    &:hover {
      border-color: v.$color-border-strong;
      box-shadow: v.$shadow-md;
      transform: translateY(-2px);
      text-decoration: none;
    }

    &:focus-visible {
      outline: 2px solid v.$color-primary;
      outline-offset: 2px;
    }
  }

  .kpi__link-cta {
    display: inline-flex;
    align-items: center;
    gap: v.$space-xs;
    color: v.$color-primary;
    font-weight: 600;
  }

  .kpi--link:hover .kpi__arrow {
    transform: translateX(3px);
  }

  .kpi__arrow {
    transition: transform 120ms ease;
  }
</style>
